// extracted by mini-css-extract-plugin
module.exports = {"heading":"SalonHeading_heading__kDoXa","title":"SalonHeading_title__Ohapw"};